module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ApplicationBrandBar'), _vm._v(" "), (_vm.badbrowser) ? _c('div', {
    staticClass: "modal modal-message modal-warning fade",
    attrs: {
      "id": "exampleModalLong",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLongTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content "
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.ieNotSupported))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.user_lang.attention))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n           " + _vm._s(_vm.user_lang.tryChrome) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.close))])])])])]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('ApplicationFooter'), _vm._v(" "), _c('SessionTimeout')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-016d20ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-016d20ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TopNavFooter.vue
// module id = 699
// module chunks = 1